import { Box } from "@mui/material";
import { isNil } from "lodash";
import { DragEvent, useState } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../../core/app/AppReducer";
import GossipStone from "../../core/assets/oot/classic/OoT_Gossip_Stone_Model.png";
import GossipStoneOoL from "../../core/assets/oot/classic/OoT_Gossip_Stone_Barren_Model.png";
import { getcCssRgbaColor } from "../../core/helpers/colorHepler";
import { OotItemDto } from "../hints/OotItemAutocomplete";


interface SphereElementProps {
    sphereLevel: number
    id: number
    barren?: boolean
    woth?: boolean
    item?: OotItemDto | null,
    onItemChange?: (item: OotItemDto | null, sphereLevel: number) => void
    changeItemLocationOnChildChange: (item: OotItemDto, sphereLevel: number, isChildReplacement?: true) => void
    isOutOfLogic?: true
}

const SphereElement = (props: SphereElementProps) => {

    let [isWoth, setIsWoth] = useState(false);
    let [playerObtain, setPlayerObtain] = useState<number>(0);
    let player1Color = useSelector((state: AppState) => state.ui.ootr.sphere.player1Color);
    let player2Color = useSelector((state: AppState) => state.ui.ootr.sphere.player2Color);
    let colors = [
        "",
        getcCssRgbaColor(player1Color),
        getcCssRgbaColor(player2Color),
    ]



    const handleRightClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {
        e.preventDefault()

        setPlayerObtain(0)
        setIsWoth(false)
        if (!isNil(props.onItemChange))
            props.onItemChange(null, props.id);
    }

    const handleClick = (e: React.MouseEvent<HTMLImageElement, MouseEvent>) => {

        if (e.ctrlKey || e.altKey) {
            setIsWoth(!isWoth);
        }
        else if (!isNil(props.item)) {
            setPlayerObtain((playerObtain + 1) % 4)
            return;
        }

    }

    const onDrop = (e: DragEvent<HTMLDivElement>) => {

        const item: OotItemDto = JSON.parse(e.dataTransfer.getData('text/plain'))
        // if item si undefined
        if (!isNil(props.onItemChange) && isNil(props.item)){
            console.log("Item is undefined, we set the item at this sphere ", props.sphereLevel)
            props.onItemChange(item, props.id);

            //if some itm must be after this item, and it is in an earlier sphere, replace all successors after this item and their children
        }
        //if item is not null, set child item
        else if (!isNil(props.onItemChange) && !isNil(props.item)){
            console.log("Item is defined, we set the item the child")
            let newItem: OotItemDto = {
                ...props.item,
                childImage: item.img,
                childName: item.name
            }
            //We set the child of this item
            props.onItemChange(newItem, props.sphereLevel);
            //We replace correctly this item in the sphere tracking
            props.changeItemLocationOnChildChange(newItem, props.sphereLevel);
          
        }

    }

    return <Box component="div" display="flex" onClick={handleClick} sx={{ marginRight: "5px" }}
        onContextMenu={handleRightClick} onDragOver={(e) => { e.preventDefault(); }} onDragEnter={(e) => { e.preventDefault(); }} onDropCapture={(e) => { }} onDrop={(e) => onDrop(e)} >
        {isNil(props.item) && <Box>
            <img src={props.isOutOfLogic ? GossipStoneOoL : GossipStone} width={"40px"} height={"40px"} alt="item"  /></Box>}
        {!isNil(props.item) && <Box maxHeight={"40px"} border={isWoth ? "solid 1px yellow" : "inherit"}
            display="flex"

            sx={{ zIndex: -999, backgroundColor: colors[playerObtain] }} >
            <Box display="flex">
                <img src={props.item.img} width={"40px"} height={"40px"} alt={props.item.name} />

            </Box>
            {!isNil(props.item.childImage) && <Box onContextMenu={(e) => { e.preventDefault(); }} display="flex" position={"absolute"} marginTop={"32px"} marginLeft={"10px"}>
                <img src={props.item.childImage} width={16} height={16} alt="childItemSphere"  />
            </Box>}
        </Box>
        }

    </Box >
}

export default SphereElement;